import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/aio/wrong-data.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-bac113c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrong-page-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "页面出问题了，请点击重试", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_action_bar = _resolveComponent("new-action-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_new_action_bar, {
      onGoBack: $setup.goBack,
      actionBarInfo: $setup.actionBarInfo,
      needShare: false
    }, null, 8, ["onGoBack", "actionBarInfo"]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.clickRefresh && $setup.clickRefresh(...args))),
      class: "content"
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_2,
        _hoisted_3
      ], true)
    ])
  ]))
}